import React, { Component } from "react";

export default class Synopsis extends Component {
  render() {
    return (
      <div>
        <p>
          Designed to facilitate early detection and improve prognostic accuracy
          of ALS, the Austen Speech study uses advanced computational technology
          and speech data (audio, video) to make subjective, reliable
          measurement tools. The study activity involves the use of Modality.ai
          Inc.’s web-based software that collects speech audio and video data
          and then uses AI and machine learning algorithms to analyze facial and
          speech metrics.
          <br />
          <br />
          Data collection can be conducted anywhere the participant feels
          comfortable, including the comfort of their own home. Each session
          lasts approximately 20 minutes, with no limit on the number of
          sessions participants can perform after signing up to participate. The
          data is stored in EverythingALS’s Platform, with access given to
          participants, researchers, and consortium members.
          <br />
        </p>
      </div>
    );
  }
}
